import { render } from "./index.vue?vue&type=template&id=2511d236&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2511d236&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user1\\project\\reghub\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2511d236"]])

export default __exports__